//
// NECESSARY DATA:
//
// THIS TAKES AN ARRAY OF ARRAYS. EACH ARRAY REPRESENTS ONE PIE CHART, DISPLAYED AS CONCENTRIC DONUTS. EXAMPLE DATA FORMAT:
//
// [[{"reassign_reason": "Contact unsucessful ", "cases": 138, "percent": 0.138, "total": 999, "displayname": "Oklahoma"}, {"reassign_reason": "Equipment unavailable ", "cases": 155, "percent": 0.155, "total": 999, "displayname": "Oklahoma"}, {"reassign_reason": "Extended ETA ", "cases": 123, "percent": 0.12300000000000001, "total": 999, "displayname": "Oklahoma"}, {"reassign_reason": "Facility closed/ Out of service ", "cases": 2, "percent": 0.002, "total": 999, "displayname": "Oklahoma"}, {"reassign_reason": "Force Spot ", "cases": 3, "percent": 0.003, "total": 999, "displayname": "Oklahoma"}, {"reassign_reason": "Long tow - required respot ", "cases": 1, "percent": 0.001, "total": 999, "displayname": "Oklahoma"}, {"reassign_reason": "Other", "cases": 286, "percent": 0.28600000000000003, "total": 999, "displayname": "Oklahoma"}, {"reassign_reason": "Shop/Driver declined call ", "cases": 291, "percent": 0.29100000000000004, "total": 999, "displayname": "Oklahoma"}], [{"reassign_reason": "Contact unsucessful ", "cases": 2456, "percent": 0.07200000000000001, "total": 34015, "displayname": "Club"}, {"reassign_reason": "Equipment unavailable ", "cases": 1381, "percent": 0.040999999999999995, "total": 34015, "displayname": "Club"}, {"reassign_reason": "Extended ETA ", "cases": 3059, "percent": 0.09, "total": 34015, "displayname": "Club"}, {"reassign_reason": "Facility closed/ Out of service ", "cases": 210, "percent": 0.006, "total": 34015, "displayname": "Club"}, {"reassign_reason": "Force Spot ", "cases": 1815, "percent": 0.053, "total": 34015, "displayname": "Club"}, {"reassign_reason": "Long tow \u2013 required respot ", "cases": 143, "percent": 0.004, "total": 34015, "displayname": "Club"}, {"reassign_reason": "Other", "cases": 20190, "percent": 0.594, "total": 34015, "displayname": "Club"}, {"reassign_reason": "Shop/Driver declined call ", "cases": 4761, "percent": 0.14, "total": 34015, "displayname": "Club"}]]
//
//


import * as d3 from 'd3';


const donutChart = function () {
	var width,
			height,
			margin = {top: 10, right: 10, bottom: 10, left: 10},
			color = d3.scaleOrdinal(["#375A8B", "#829DC2", "#5374A1", "#214577", "#10315E", "#5B398F", "#9F85C6", "#7657A7", "#45237B", "#301161", "#369F4D", "#87D498", "#57B96D", "#1D8935", "#096C1F"]), // color scheme
			variable, // value in data that will dictate proportions on chart
			category, // compare data by
			padAngle, // effectively dictates the gap between slices
			floatFormat = d3.format('s'),
			cornerRadius, // sets how rounded the corners are on each slice
			percentFormat = d3.format(',.0%'),
			bandwidths = [[.85, .65], [.63, .55], [.3, .4]];
	
	var chart = function (selection) {
		selection.each(function (data) {
			
			
			
			// Set up constructors for making donut.
			var radius = Math.min(width, height) / 2;
			
			// append the svg object to the selection
			var svg = selection.append('svg')
			
			
			var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
			
			if (isIE11) {
				svg.attr('height', (height + margin.top + margin.bottom))
						.attr('width', (width + margin.left + margin.right))
				
			} else {
				svg
						.attr("preserveAspectRatio", "xMinYMin meet")
						.attr("viewBox", "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom))
				
			}
			
			var wrapper = svg
					.append('g')
					.attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
			
			// g elements to keep elements within svg modular
			wrapper.append('g').attr('class', 'labelName');
			wrapper.append('g').attr('class', 'lines');
			
			
			var multiring;
			
			if (Array.isArray(data[0])) {
				multiring = true;
			} else {
				multiring = false;
			}
			if (multiring && Object.keys(data).length > 3) console.error('Too many rings are being drawn in the donutchart.')
			
			function editData(arr) {
				arr.forEach(function (d, i) {
					d['color'] = color(d[category]);
					d['variable'] = variable;
					d['category'] = category;
				})
			}
			
			if (multiring) {
				data.forEach(function (a) {
					editData(a);
				})
			}
			else {
				editData(data)
			}
			
			
			function draw(idx) {
				
				let pdata = data[idx];
				
				// creates a new pie generator
				var pie = d3.pie()
						.value(function (d) {
							return d[variable];
						}) //may need to call floatFormat(d[variable])
						.sort(null);
				
				// constructs an arc generator. This will be used for the donut. The difference between outer and inner
				// radius will dictate the thickness of the donut
				
				
				var arc = d3.arc()
						.outerRadius(radius * bandwidths[idx][0])
						.innerRadius(radius * bandwidths[idx][1])
						.cornerRadius(cornerRadius)
						.padAngle(padAngle);
				
				
				wrapper.append('g').attr('class', 'slices slices-' + idx)
				
				// add and color the donut slices
				var path = wrapper.select('.slices-' + idx)
						.datum(pdata).selectAll('path')
						.data(pie)
						.enter().append('path')
						.attr('fill', function (d) {
							return color(d.data[category]);
						})
						.attr('d', arc);
				
				//label this arc on condition
				if (!idx) labelArc();
				
				
				function labelArc() {
					// this arc is used for aligning the text labels
					
					var outerArc = d3.arc()
							.outerRadius(radius * 0.9)
							.innerRadius(radius * 0.9);
					
					
					(function addLabels() {
						
						
						var label = wrapper.select('.labelName')
								.datum(pdata)
								.selectAll('text')
								.data(pie)
								.enter().append('text')
								.attr('dy', '.35em')
								.html(function (d, i) {
									// add "key: value" for given category. Number inside tspan is bolded in stylesheet.
									//remove labels for values under 5% to avoid label overlap and clutter
									if (d.data[variable] > 0.05) {
										return d.data[category] + ': <tspan>' + percentFormat(d.data[variable]) + '</tspan>';
									}
									else {
										return '<tspan></tspan>'
									}
								})
								.attr('transform', function (d) {
									// effectively computes the centre of the slice.
									var pos = outerArc.centroid(d);
									
									// changes the point to be on left or right depending on where label is.
									pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
									return 'translate(' + pos + ')';
								})
								.style('text-anchor', function (d) {
									// if slice centre is on the left, anchor text to start, otherwise anchor to end
									return (midAngle(d)) < Math.PI ? 'start' : 'end';
								});
					})();
					
					(function addPolyline() {
						
						// add lines connecting labels to slice. A polyline creates straight lines connecting several points
						var polyline = wrapper.select('.lines')
								.datum(pdata)
								.selectAll('polyline')
								.data(pie)
								.enter().append('polyline')
								.attr('points', function (d) {
									
									if (d.data[variable] > 0.05) {
										var pos = outerArc.centroid(d);
										pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
										return [arc.centroid(d), outerArc.centroid(d), pos]
									}
									else {
										void(0)
									}
									
								});
						
						
					})();
					
				} //labelarc
				
			} //draw
			
			
			data.forEach(function (d, i) {
				draw(i);
			});
			
			
			// add tooltip to mouse events on slices and labels
			d3.selectAll('.labelName text, .slices path').call(toolTip);
			
			// Functions
			
			// calculates the angle for the middle of a slice
			function midAngle(d) {
				return d.startAngle + (d.endAngle - d.startAngle) / 2;
			}
			
			// function that creates and adds the tool tip to a selected element
			function toolTip(selection) {
				
				// add tooltip (svg circle element) when mouse enters label or slice
				selection.on('mouseenter', function (data) {
					
					d3.select(this.parentNode.parentNode).append('text')
							.attr('class', 'toolCircle')
							.attr('dy', '5em') // hard-coded. can adjust this to adjust text vertical alignment in tooltip
							.html(toolTipHTML(data, this)) // add text to the circle.
							.style('font-size', '.9em')
							.style('text-anchor', 'middle'); // centres text in tooltip
					
					wrapper.append('circle')
							.attr('class', 'toolCircle')
							.attr('r', radius * 0.55) // radius of tooltip circle
							.style('fill', color(data.data[category])) // color based on category mouse is over
							.style('fill-opacity', 0); //can color in the inner circle if we want to. Currently off.
					
				});
				
				// remove the tooltip when mouse leaves the slice/label
				selection.on('mouseout', function () {
					d3.selectAll('.toolCircle').remove();
				});
			}
			
			//re-writing this function to get the cool effects that I want!
			// THIS SECTION OF THE CODE IS NOT COMPATIBLE WITH REUSABLE CHARTS. EDIT BEFORE NEW APPLICATION.
			function toolTipHTML(data, _this) {
				
				var tip = '';
				var thiscolor = d3.hsl(_this.getAttribute('fill'));
				var darkercolor = thiscolor.darker();
				
				tip += '<tspan x="0" dy="-.2em" text-anchor: "middle" class = "variable-highlight" stroke = "' + thiscolor + '">' + percentFormat(data.data[data.data['variable']]) + '</tspan>';
				tip += '<tspan x="0" dy="2em" text-anchor: "middle" class = "incident-count" fill = "' + thiscolor + '">' + data.data['displayname'] + ':</tspan>';
				tip += '<tspan x="0" dy="1em" text-anchor: "middle" class = "incident-count" fill = "' + thiscolor + '">' + data.data[data.data['category']] + '</tspan>';
				tip += '<tspan x="0" dy="1em" text-anchor: "middle" class = "incident-count" fill = "' + darkercolor + '">Calls:</tspan>';
				tip += '<tspan x="0" dy="1em" text-anchor: "middle" class = "incident-count" fill = "' + darkercolor + '">' + data.data['cases'] + ' out of ' + data.data['total'] + '</tspan>';
				
				return tip;
			}
			
			
		});
	}
	
	
	chart.width = function (value) {
		if (!arguments.length) return width;
		width = value;
		return chart;
	};
	
	chart.height = function (value) {
		if (!arguments.length) return height;
		height = value;
		return chart;
	};
	
	chart.margin = function (value) {
		if (!arguments.length) return margin;
		margin = value;
		return chart;
	};
	
	chart.padAngle = function (value) {
		if (!arguments.length) return padAngle;
		padAngle = value;
		return chart;
	};
	
	chart.cornerRadius = function (value) {
		if (!arguments.length) return cornerRadius;
		cornerRadius = value;
		return chart;
	};
	
	chart.color = function (value) {
		if (!arguments.length) return color;
		color = value;
		return chart;
	};
	
	chart.variable = function (value) {
		if (!arguments.length) return variable;
		variable = value;
		return chart;
	};
	
	chart.category = function (value) {
		if (!arguments.length) return category;
		category = value;
		return chart;
	};
	
	//array of arrays of decimals that represent the size of each ring of the chart as a multiplier of the radius
	chart.bandwidths = function (value) {
		if (!arguments.length) return bandwidths;
		bandwidths = value;
		return chart;
	};
	
	
	return chart;
}


//finished


export default donutChart;
